import React, { FC, ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { Button } from 'components/atoms/button';
import { ClassNameOnlyProps } from 'components/ozone-component';

export interface Action {
  title: ReactNode;
  onClick: () => void;
  disabled?: boolean;
}

interface Props extends ClassNameOnlyProps {
  primary: Action;
  secondary?: Action;
  other?: Action[];
  reverse?: boolean;
}

const ActionButton: FC<Action & { type?: 'link' } & ClassNameOnlyProps> = ({
  className,
  title,
  onClick,
  disabled,
  type,
}) => (
  <Button
    className={className}
    size="small"
    type={type ?? 'text'}
    onClick={onClick}
    disabled={disabled}
  >
    {title}
  </Button>
);

const Wrapper = styled.div<{ $reverse: boolean }>`
  display: flex;
  align-items: center;
  flex-direction: ${({ $reverse }) => ($reverse ? 'row-reverse' : 'row')};

  ${Button} {
    padding: 0 calc(var(--spacing-05) - 1px);
    ${({ $reverse }) =>
      !$reverse &&
      css`
        margin-right: var(--spacing-02);
      `};
    ${({ $reverse }) =>
      $reverse &&
      css`
        margin-left: var(--spacing-02);
      `};

    &:last-child {
      margin: 0;
    }
  }
`;

const ActionFooterComponent: FC<Props> = ({
  className,
  primary,
  secondary,
  other = [],
  reverse,
}) => (
  <Wrapper className={className} $reverse={!!reverse}>
    <ActionButton type="link" {...primary} />
    {secondary == null ? null : <ActionButton {...secondary} />}
    {other.map((action) => (
      <ActionButton {...action} />
    ))}
  </Wrapper>
);

export const ActionFooter = styled(ActionFooterComponent)``;
